// Pure helpers for turning admin input into a clean, de-duplicated list of
// locker numbers. Kept dependency-free so it is trivially testable and
// shared between the manual-entry and range-entry paths of the locker config UI.

/**
 * Parse free-form text ("101, 102 A5") into a de-duplicated array of locker numbers.
 * Locker numbers are free-form strings — numeric or alphanumeric ("A12") — so tokens are
 * kept as trimmed strings rather than coerced to integers.
 */
export function parseManualNumbers(text) {
  if (!text) return [];
  const seen = new Set();
  const result = [];
  for (const token of String(text).split(/[\s,]+/)) {
    const trimmed = token.trim();
    if (trimmed === '' || seen.has(trimmed)) continue;
    seen.add(trimmed);
    result.push(trimmed);
  }
  return result;
}

/** Expand an inclusive numeric range into an array. Returns [] for invalid input. */
export function expandRange(from, to) {
  const a = parseInt(from, 10);
  const b = parseInt(to, 10);
  if (Number.isNaN(a) || Number.isNaN(b) || a > b) return [];
  const out = [];
  for (let i = a; i <= b; i++) out.push(i);
  return out;
}
